import React, { useState, useEffect } from "react";
import { Button, Form, Dropdown, Label, Grid, Segment } from "semantic-ui-react";
import PropTypes from "prop-types";
import moment from "moment";

import { truncate, isEmpty, map, includes, isNumber, toLower, isEqual, get, some } from "lodash";
import Joi from "joi";

// redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import dataHandler from "@Utils/dataHandler";

// Components
import Input from "@Components/Input";
import Text from "@Components/Text";
import IKModal from "@Components/IkModal";
import FileManager from "@Components/FileManager";
import TextArea from "@Components/TextArea";
import MultiSelect from "@Components/MultiSelect";

// ModalS
import ImageView from "@Modals/ImageView";
import ConfirmModal from "@Modals/ConfirmModal";
import CategoryCrud from "@Features/Category/Modals/CategoryCrud";

// Utils
import { dropdownFormat } from "@Utils/formats";
import archiveOption from "../../staticData";

// Styles
import styles from "./styles.module.css";

const QuickAnswersCrud = ({
	modalCrud,
	tableValue,
	apiData,
	dispatch,
	userName,
	onClose,
	profilesList,
	groupsList,
	quickAnswersList,
	refresh,
}) => {
	const schema = Joi.object().keys({
		fileVerificacion: Joi.string().messages({
			"string.empty": "Archivo es un campo requerido",
		}),

		title: Joi.string().messages({
			"string.empty": "Título es un campo requerido",
		}),
		// repeatTitle: Joi.string().messages({
		// 	"string.empty": "El Título ya existe",
		// }),
		messageArea: Joi.string().messages({
			"string.empty": "Texto es un campo requerido",
		}),
		// repeat: Joi.string().messages({
		// 	"string.empty": "El hotkey ya existe",
		// }),
		hotkey: Joi.string().allow("").max(10).messages({
			"string.max": "Hotkey no puede tener más de 10 caracteres",
		}),
	});

	const [categoryData, setTypesData] = useState([]);
	const [departamentData, setDepartamentData] = useState([]);
	const [agentData, setAgentData] = useState([]);
	const [open, setOpen] = useState(false);
	const [openImage, setOpenImage] = useState(false);
	const [images, setImages] = useState([]);
	const [fileImage, setFileImage] = useState("");
	const [dataAll, setDataAll] = useState("");
	const [modalOption, setModalOption] = useState("");
	const [initialFormData, setInitialFormData] = useState([]);
	const [openModalCategory, setOpenCategoryModal] = useState(false);
	const [activeTab, setActiveTab] = useState("info");
	const tabsButtons = [
		{ key: "1", state: "info", label: "Info.", icon: "info circle", order: 1 },
		{ key: "2", state: "config", label: "Configuración", icon: "setting", order: 2 },
	];
	const [formData, setFormData] = useState({
		typeRadio: "Text",
		admin: "",
		category: "",
		agent: [],
		departament: [],
		formatFile: ".txt",
		filter: "",
		fileText: "",
		hotkey: "",
		title: "",
		fileVerificacion: "correct",
		fileData: {},
		messageArea: "",
	});
	const [errors, setErrors] = useState({
		fileVerificacion: "",
		repeatTitle: "",
		repeatHotkey: "",
		hotkey: "",
		title: "",
		messageArea: "",
	});

	useEffect(() => {
		(async () => {
			setModalOption(modalCrud);

			const categoriesResponse = await dispatch(genericAction({ method: "get", route: "category/all" }));
			const filteredCategories = categoriesResponse.filter((category) => {
				return includes(category.restriction, "quickanswers");
			});
			const categoryDataVal = dropdownFormat(filteredCategories, "name", "id");
			const agentDataVal = dropdownFormat(profilesList, "user.fullName", "userId");
			const departamentDataVal = dropdownFormat(groupsList, "name", "id");

			setDepartamentData(departamentDataVal);
			setTypesData(categoryDataVal);
			setAgentData(agentDataVal);

			if (modalCrud !== "Add" && tableValue?.id) {
				const quickAnswersResponse = await dataHandler({
					dispatch,
					url: `quickAnswers/${tableValue.id}`,
				});
				setDataAll(quickAnswersResponse);

				const groupsId = map(get(quickAnswersResponse, "groups", []), "id");
				const logo = get(quickAnswersResponse, "uri", []);
				setImages(logo ? [logo] : []);

				const newFormData = {
					messageArea: get(quickAnswersResponse, "text", ""),
					category: get(quickAnswersResponse, "categoryId", ""),
					fileData: get(quickAnswersResponse, "uri", {}),
					agent: get(quickAnswersResponse, "userIds") || map(get(quickAnswersResponse, "users", []), "id"),
					departament: groupsId,
					admin: userName,
					hotkey: get(quickAnswersResponse, "hotkey", "") || "",
					title: get(quickAnswersResponse, "name", ""),
					fileText: get(quickAnswersResponse, "uri", ""),
					typeRadio: get(quickAnswersResponse, "type", "Text"),
				};

				setFormData(newFormData);
				setInitialFormData(newFormData);
				setFileImage(get(quickAnswersResponse, "uri", {}));
			} else {
				const emptyFormData = {
					typeRadio: "Text",
					category: "",
					agent: [],
					departament: [],
					formatFile: ".txt",
					filter: "",
					fileText: "",
					admin: userName,
					hotkey: "",
					title: "",
					fileVerificacion: "correct",
					fileData: {},
					messageArea: "",
				};
				setFormData(emptyFormData);
				setInitialFormData(emptyFormData);
			}
		})();
	}, [modalCrud, tableValue, profilesList, groupsList, userName, dispatch]);

	// save handlers
	const savedData = async () => {
		let repeatTitle = "";
		let repeatHotkey = "";

		if (!isEmpty(formData.title)) {
			const titleExists = quickAnswersList.some((item) => {
				return item.id !== dataAll?.id && toLower(item.name) === toLower(formData.title);
			});
			if (titleExists) {
				repeatTitle = "El Título ya existe";
			}
		}

		if (!isEmpty(formData.hotkey)) {
			const hotkeyExists = quickAnswersList.some((item) => {
				return item.id !== dataAll?.id && toLower(item.hotkey) === toLower(formData.hotkey);
			});
			if (hotkeyExists) {
				repeatHotkey = "El Hotkey ya existe";
			}
		}

		const fileVerificacion = formData.typeRadio !== "Text" && isEmpty(images) ? "" : "ok";
		let validation = {};
		if (formData.typeRadio === "Text") {
			validation = schema.validate(
				{
					fileVerificacion,
					messageArea: formData.messageArea,
					title: formData.title,
					hotkey: formData.hotkey,
				},
				{ abortEarly: false }
			);
		} else {
			validation = schema.validate(
				{
					fileVerificacion,
					title: formData.title,
					hotkey: formData.hotkey,
				},
				{ abortEarly: false }
			);
		}

		if (validation.error || !isEmpty(repeatTitle) || !isEmpty(repeatHotkey)) {
			const { details } = validation.error || { details: [] };
			let errorsVal = {
				title: "",
				messageArea: "",
				fileVerificacion: "",
				repeatTitle,
				repeatHotkey,
			};

			if (details) {
				map(details, (item) => {
					errorsVal = { ...errorsVal, [item.context.key]: item.message };
				});
			}
			setErrors(errorsVal);
			return;
		}
		const formatValues = (value) => {
			return isNumber(value) ? value : null;
		};

		const currentGroups = formData.departament || [];
		const initialGroups = dataAll?.groupIds || map(get(dataAll, "groups", []), "id");

		const groupIdsAdd = currentGroups.filter((id) => {
			return !initialGroups.includes(id);
		});
		const groupIdsRemove = initialGroups.filter((id) => {
			return !currentGroups.includes(id);
		});

		const currentUsers = formData.agent || [];
		const initialUsers = dataAll?.userIds || map(get(dataAll, "users", []), "id");

		const userIdsAdd = currentUsers.filter((id) => {
			return !initialUsers.includes(id);
		});
		const userIdsRemove = initialUsers.filter((id) => {
			return !currentUsers.includes(id);
		});

		if (!isEmpty(dataAll)) {
			const dataToEditor = {};

			if (formData.title !== dataAll.name) dataToEditor.name = formData.title;
			if (formData.messageArea !== dataAll.text) dataToEditor.text = formData.messageArea;
			if (formData.hotkey !== dataAll.hotkey) dataToEditor.hotkey = formData.hotkey;
			if (formData.typeRadio !== dataAll.type) dataToEditor.type = formData.typeRadio;
			if (!isEmpty(images) && !isEqual(images, [get(dataAll, "uri")])) {
				dataToEditor.uri = images;
			}

			const categoryId = formatValues(formData.category);
			if (categoryId !== dataAll.categoryId) dataToEditor.categoryId = categoryId;

			if (!isEmpty(userIdsAdd)) dataToEditor.userIds = userIdsAdd;
			if (!isEmpty(userIdsRemove)) dataToEditor.userIdsD = userIdsRemove;

			if (!isEmpty(groupIdsAdd)) dataToEditor.groupIds = groupIdsAdd;
			if (!isEmpty(groupIdsRemove)) dataToEditor.groupIdsD = groupIdsRemove;

			if (!isEmpty(dataToEditor)) {
				const dataEdit = await dispatch(
					genericAction({
						method: "patch",
						route: `quickAnswers/${parseInt(dataAll.id, 10)}`,
						body: dataToEditor,
					})
				);

				if (!isEmpty(dataEdit)) {
					apiData("Edit", dataEdit);
				}
			}
		} else {
			const data = {
				hotkey: formData.hotkey,
				groupIds: currentGroups.filter(isNumber),
				text: formData.messageArea,
				name: formData.title,
				type: formData.typeRadio,
				userIds: currentUsers.filter(isNumber),
				categoryId: formatValues(formData.category),
				uri: !isEmpty(images) ? images : null,
			};

			const dataAdd = await dispatch(
				genericAction({
					method: "post",
					route: "quickAnswers",
					body: data,
				})
			);

			if (!isEmpty(dataAdd)) {
				setFormData({
					typeRadio: "Text",
					category: "",
					agent: [],
					departament: [],
					formatFile: ".txt",
					filter: "",
					fileText: "",
					admin: userName,
					hotkey: "",
					title: "",
					fileVerificacion: "correct",
					fileData: {},
					messageArea: "",
				});
				apiData("Add", dataAdd);
			}
		}
		setErrors({
			fileVerificacion: "",
			repeatTitle: "",
			repeatHotkey: "",
			hotkey: "",
			title: "",
			messageArea: "",
		});
	};

	/// archive handlers
	const convertStringArchive = (string) => {
		switch (string) {
			case "Image":
				return "image/*";
			case "Document":
				return "*/*";
			case "Text":
				return ".txt";
			default:
				return "";
		}
	};
	const convertStringTitle = (string) => {
		switch (string) {
			case "Image":
				return "Imagen";

			case "Document":
				return "Archivo";

			case "Text":
				return "Desactivado";

			default:
				return "";
		}
	};
	const archiveOptionHandler = (event, { name, value }) => {
		setImages([]);
		if (value === "Document") {
			setFormData({
				...formData,
				[name]: value,

				messageArea: "",
				fileText: "Ningún Documento seleccionado",
				fileData: {},
			});
		} else {
			if (value === "Image") {
				setFormData({
					...formData,
					[name]: value,
					fileText: "Ningún Documento seleccionado",
					fileData: {},
				});
				setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
			} else if (value === "Text") {
				setFormData({
					...formData,
					fileData: {},
					fileText: "",
					[name]: value,
				});
			}
			setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
		}
	};

	// input handlers
	const handleInputDropdown = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		if (name === "title") {
			setErrors((prev) => {
				return {
					...prev,
					repeatTitle: "",
				};
			});
		}
		if (name === "hotkey") {
			setErrors((prev) => {
				return {
					...prev,
					repeatHotkey: "",
				};
			});
		}
	};
	const handleInputTextArea = (e) => {
		const { value } = e.target;
		let number = value;
		if (value.length > 499) {
			number = truncate(value, {
				length: 500,
				omission: "",
			});
		}
		setFormData({
			...formData,
			messageArea: number,
		});
	};

	// modal handlers
	const cancelModal = () => {
		onClose();
	};
	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const handleCloseCategoryModal = async (newCategory) => {
		setOpenCategoryModal(false);

		if (newCategory?.id) {
			const newOption = {
				text: newCategory.name,
				value: newCategory.id,
			};

			setTypesData((prev) => {
				const exists = some(prev, { value: newOption.value });
				return exists ? prev : [...prev, newOption];
			});

			setFormData((prev) => {
				return {
					...prev,
					category: newCategory.id,
				};
			});
		}
		await refresh();
	};

	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Respuesta Rápida" : `Respuesta Rápida: ${get(dataAll, "name", "")} `}
				id={dataAll.id}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={savedData}
				size="small"
				saveDisabled={isEqual(initialFormData, formData)}
				fullHeight
				tabs={tabsButtons}
				activeTab={activeTab}
				onTabChange={setActiveTab}>
				<Grid className={styles.grid}>
					<Grid.Row className={styles.grid}>
						<Grid.Column width={16} className={styles.grid}>
							<div className={styles.container}>
								{activeTab === "info" && (
									<>
										<div className={styles.containerGroup}>
											<div className={styles.containerGroupR}>
												<Form>
													<Input
														icon="barcode"
														label="Título:"
														required
														placeholder="Título"
														name="title"
														disabled={modalOption === "Watch"}
														fluid
														error={!isEmpty(errors.title) && { content: errors.title, pointing: "above" }}
														className={styles.inputChannel}
														value={formData.title}
														onChange={handleInput}
													/>
													<Label
														className={styles.messageError}
														style={isEmpty(errors.repeatTitle) ? { display: "none" } : null}
														pointing
														prompt>
														{errors.repeatTitle}
													</Label>
													<Form className={styles.containerGroupFin}>
														<div className={styles.rowTitleImg}>
															<Text className={styles.textArea}>Hotkey:</Text>
															<Text className={formData.hotkey?.length > 10 ? styles.textAreaColor : styles.textArea}>
																{formData.hotkey?.length || 0}/10
															</Text>
														</div>

														<Input
															icon="barcode"
															placeholder="Hotkey"
															disabled={modalOption === "Watch"}
															name="hotkey"
															fluid
															className={styles.inputChannel}
															value={formData.hotkey}
															onChange={handleInput}
															error={!isEmpty(errors.hotkey) && { content: errors.hotkey, pointing: "above" }}
															// maxLength={5}
														/>
														{!isEmpty(formData.hotkey) && !isEmpty(errors.repeatHotkey) && (
															<Label className={styles.messageError} pointing prompt>
																{errors.repeatHotkey}
															</Label>
														)}
													</Form>

													<div className={styles.containerGroupFin}>
														<Text required className={isEmpty(errors.typeRadio) ? styles.textBox : styles.textBoxColor}>
															Formato: <span className={styles.required}>*</span>
														</Text>
														<Dropdown
															value={formData.typeRadio}
															name="typeRadio"
															disabled={modalOption === "Watch"}
															error={!isEmpty(errors.typeRadio)}
															onChange={archiveOptionHandler}
															clearable
															placeholder="Elegir"
															fluid
															selection
															options={archiveOption}
														/>
													</div>
												</Form>
											</div>

											<div className={styles.containerGroupR}>
												<Form>
													<Form className={styles.containerGroupFin} style={{ visibility: "hidden" }}>
														<div className={styles.rowTitleImg}>
															<Text className={styles.textBox}>Spacer</Text>
														</div>
														<Input disabled />
													</Form>
													{formData.typeRadio !== "Text" && (
														<Form className={styles.containerGroupFin} style={{ visibility: "hidden" }}>
															<div className={styles.rowTitleImg}>
																<Text className={styles.textBox}>Spacer</Text>
															</div>
															<Input disabled />
														</Form>
													)}
													<div className={`${styles.containerGroupFin} ${styles.shiftUp}`}>
														{formData.typeRadio === "Text" && (
															<>
																<Text disabled className={styles.textFont}>
																	{formData.fileText}
																</Text>
																<Label
																	className={styles.messageErrorTextBox}
																	style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
																	pointing
																	prompt>
																	{errors.fileVerificacion}
																</Label>
															</>
														)}
														{formData.typeRadio === "Image" && (
															<>
																<Text className={styles.textBox}>Imagen:</Text>
																<FileManager images={images} setImages={setImages} disabled={modalOption === "Watch"} />
																<Label
																	className={styles.messageErrorTextBox}
																	style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
																	pointing
																	prompt>
																	{errors.fileVerificacion}
																</Label>
															</>
														)}

														{formData.typeRadio !== "Text" && formData.typeRadio !== "Image" && (
															<>
																<Text className={styles.textBox}>{convertStringTitle(formData.typeRadio)}:</Text>
																<FileManager
																	images={images}
																	setImages={setImages}
																	type="file"
																	accept={convertStringArchive(formData.typeRadio)}
																	disabled={modalOption === "Watch"}
																/>
																<Label
																	className={styles.messageErrorTextBox}
																	style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
																	pointing
																	prompt>
																	{errors.fileVerificacion}
																</Label>
															</>
														)}
													</div>
												</Form>
											</div>
										</div>

										<Form className={styles.containerGroupFin}>
											<div className={styles.rowTitleImg}>
												<Text className={styles.textArea}>
													Texto: {formData.typeRadio === "Text" && <span className={styles.required}>*</span>}
												</Text>
												<Text className={get(formData, "messageArea", "").length === 500 ? styles.textAreaColor : styles.textArea}>
													{get(formData, "messageArea", "").length}
													/500
												</Text>
											</div>
											<TextArea
												disabled={formData.typeRadio === "Document" ? true : modalOption === "Watch"}
												value={formData.messageArea}
												placeholder={`Escribir texto,\nComodín {{usuario}} {{contacto}} {{perfil}}`}
												name="messageArea"
												className={styles.textareaAutosize}
												onChange={handleInputTextArea}
												minRows={1}
											/>
											<Label
												className={styles.messageErrorTextBox}
												style={isEmpty(errors.messageArea) ? { display: "none" } : null}
												pointing
												prompt>
												{errors.messageArea}
											</Label>
										</Form>
									</>
								)}

								{activeTab === "config" && (
									<div className={styles.containerGroup}>
										<div
											className={styles.containerGroupFin}
											style={{ width: "100%", display: "flex", flexDirection: "column", gap: "15px" }}>
											<Form>
												<div className={styles.configRow}>
													<fieldset className={styles.configFieldset}>
														<legend className={styles.configLegend}>
															<Text className={`${isEmpty(errors.agent) ? styles.textBox : styles.textBoxColor} ${styles.legendText}`}>
																Usuario:
															</Text>
														</legend>
														<MultiSelect
															placeholder="Seleccionar"
															value={formData.agent}
															disabled={modalOption === "Watch"}
															name="agent"
															onChange={handleInputDropdown}
															options={agentData}
														/>
													</fieldset>

													<fieldset className={styles.configFieldset}>
														<legend className={styles.configLegend}>
															<Text
																className={`${isEmpty(errors.departament) ? styles.textBox : styles.textBoxColor} ${styles.legendText}`}>
																Grupo:
															</Text>
														</legend>
														<MultiSelect
															placeholder="Seleccionar"
															value={formData.departament}
															disabled={modalOption === "Watch"}
															name="departament"
															onChange={handleInputDropdown}
															options={departamentData}
														/>
													</fieldset>
												</div>

												<div className={styles.configRowMargin}>
													<fieldset className={styles.configFieldset}>
														<legend className={styles.configLegend}>
															<Text className={`${isEmpty(errors.category) ? styles.textBox : styles.textBoxColor} ${styles.legendText}`}>
																Categoría:
															</Text>
														</legend>
														<div className={styles.containerCategory}>
															<Dropdown
																value={formData.category}
																options={categoryData}
																fluid
																disabled={modalOption === "Watch"}
																clearable
																placeholder="Seleccionar"
																name="category"
																className={styles.inputDropdown}
																onChange={handleInputDropdown}
																search
																selection
															/>
															<Button
																className={styles.buttonClass}
																icon="plus"
																disabled={modalOption === "Watch"}
																onClick={() => {
																	setOpenCategoryModal(true);
																}}
															/>
														</div>
													</fieldset>
													<fieldset className={styles.configFieldset} style={{ visibility: "hidden" }} />
												</div>
											</Form>
										</div>
									</div>
								)}
							</div>
							{modalOption !== "Add" && (
								<Segment color="blue" className={styles.infoSegment}>
									<div className={styles.infoBlock}>
										{formData.admin && (
											<div>
												<strong className={styles.spanSegment}>Creado por:</strong> {formData.admin}
											</div>
										)}
										{(dataAll?.createdDate || dataAll?.createdAt) && (
											<div>
												<strong className={styles.spanSegment}>Fecha creación:</strong>{" "}
												{moment(dataAll.createdDate || dataAll.createdAt).format("DD/MM/YYYY")}
											</div>
										)}
									</div>
								</Segment>
							)}
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</IKModal>
			{openImage && (
				<ImageView
					visible
					fileImage={fileImage}
					onClose={() => {
						setOpenImage(false);
					}}
				/>
			)}
			{open && (
				<ConfirmModal
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
			{openModalCategory && (
				<CategoryCrud
					modalCrud="Add"
					defaultType="quickanswers"
					tableValue={{}}
					onClose={handleCloseCategoryModal}
					dispatch={dispatch}
					refresh={refresh}
				/>
			)}
		</>
	);
};

function mapStateToProps({ user }) {
	return {
		gruposData: [],
		agentsData: [],
		categoryArray: [],
		userName: user.name,
	};
}
QuickAnswersCrud.propTypes = {
	tableValue: PropTypes.object,
	profilesList: PropTypes.array,
	quickAnswersList: PropTypes.array,
	groupsList: PropTypes.array,
	apiData: PropTypes.func,
	dispatch: PropTypes.func,
	userName: PropTypes.string,
	modalCrud: PropTypes.string,
	onClose: PropTypes.func,
	refresh: PropTypes.func,
};
export default connect(mapStateToProps)(QuickAnswersCrud);
